import SearchResultsAircraft from './SearchResultsAircraft';
export default SearchResultsAircraft;
